import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../style/Fournisseur.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import NotesMutuelle from "./NotesMutuelle.jsx";
import SunEditor from "suneditor-react";
import { useHistory } from "react-router-dom";
import { logOut } from "../../utils/login";
import "suneditor/dist/css/suneditor.min.css";

import { useToasts } from "react-toast-notifications";
import { MDBIcon } from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function Mutuelle() {
  const [mutuelle, setMutuelle] = useState([]);
  const { mutuelleId } = useParams();
  const [notes, setNotes] = useState();
  const [refresh, setRefresh] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const loggedIn = useSelector((state) => state.login);
  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const getMutuelle = () => axios.get(`${API_URL}/api/mutuelles/${mutuelleId}`);
  const getNotes = () =>
    axios.get(`${API_URL}/api/notes/mutuelle/${mutuelleId}`, {
      headers: { authorization: `Bearer ${token}` },
    });

  useEffect(() => {
    function getMutuelleAndNotes() {
      axios
        .all([getMutuelle(), loggedIn ? getNotes() : null])
        .then((res) => {
          setMutuelle(res[0].data);
          if (loggedIn && res[1].data.notes) {
            setNotes(res[1].data.notes);
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }

    getMutuelleAndNotes();
  }, [refresh]);

  return (
    <div className="fournisseurMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{mutuelle.nom}</title>
      </Helmet>
      <a
        href={mutuelle.site_internet}
        target="_blank"
        rel="noreferrer"
        className="fournisseurTitleSpan"
      >
        <span>
          {mutuelle.id ? (
            <img
              src={`${API_URL}/images/mutuelles/${mutuelle.id}.png`}
              alt="Logo"
              className="fournisseurLogo"
            />
          ) : (
            "Loading"
          )}
          <h1>
            {mutuelle.nom
              ? `${mutuelle.nom.charAt(0).toUpperCase()}${mutuelle.nom.slice(
                  1
                )}`
              : null}
          </h1>
        </span>
      </a>
      <h2>Contact</h2>
      <span className="contactFirstLine">{mutuelle.nom}</span>
      {mutuelle.adresse_rue_1}
      <br />
      {mutuelle.adresse_rue_2}
      {mutuelle.adresse_rue_2 ? <br /> : null}
      {mutuelle.adresse_code_postal} {mutuelle.adresse_ville}
      <br />
      {mutuelle.adresse_pays}
      {mutuelle.adresse_pays ? <br /> : null}
      <br />
      <MDBIcon icon="globe" />{" "}
      <a href={mutuelle.site_internet} target="_blank" rel="noreferrer">
        Site internet
      </a>
      <br />
      <MDBIcon icon="phone" /> {mutuelle.telephone}
      <br />
      {mutuelle.fax && (
        <div>
          <MDBIcon icon="fax" /> {mutuelle.fax}
          <br />
        </div>
      )}
      {mutuelle.email && (
        <div>
          <MDBIcon icon="envelope" />{" "}
          <a href={`mailto: ${mutuelle.email}`}> {mutuelle.email} </a>
          <br />
        </div>
      )}
      <h2 className="FournisseursH2">Notes</h2>
      <SunEditor
        lang="fr"
        width="80%"
        height="auto"
        autoFocus={true}
        setContents={notes}
        disable={true}
        showToolbar={false}
        setOptions={{ showPathLabel: false, resizingBar: false }}
      />
      <NotesMutuelle
        notes={notes}
        setNotes={setNotes}
        mutuelleId={mutuelleId}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </div>
  );
}

export default Mutuelle;
